import { fromEvent } from 'rxjs';
import ControllerBase from '../../../../global/js/ControllerBase';
import UIkit from 'uikit';
import { OrganismFormStepperEvents } from 'wolf/components/organisms/o-form-stepper/o-form-stepper.events';

type ComponentRefs = {
    ctaEditStep: 'cta-edit-step';
};


export enum ResumeSliceEvents {
    TOGGLE_SLICE_FOR_INPUTS = 'TOGGLE_SLICE_FOR INPUTS'
}

export default class ControllerFormStepResumeSlice extends ControllerBase<ComponentRefs> {
    ctaEditStep: HTMLButtonElement
    stepToVisit: number | null

    private static readonly componentRefs: ComponentRefs = {
        ctaEditStep: 'cta-edit-step',
    };

    constructor(element: HTMLElement) {
        super(element, [], Object.values(ControllerFormStepResumeSlice.componentRefs));
        this.ctaEditStep = this.$references[ControllerFormStepResumeSlice.componentRefs.ctaEditStep]
        this.stepToVisit = Number(this.ctaEditStep.getAttribute('data-step-idx'))
        this.observeRemoveFormPartRequest()
    }

    observeRemoveFormPartRequest(): void {
        // console.log(this.ctaEditStep)
        const click$ = fromEvent(this.ctaEditStep, 'click');

        click$.subscribe((e: Event | MouseEvent) => {
			e.preventDefault();
            this.handleEditStep();
        });
    }

    handleEditStep(): void {
        // Switcher steps starts from 0
        const ctaEditStepData = this.ctaEditStep.dataset
        const ctaOriginalStep = Number(ctaEditStepData.stepIdx)
        const resumeSliceId = ctaEditStepData.sliceId

        const currentSwitcher = document.getElementById('wolf-form-stepper')

        if (currentSwitcher) {
            const activeStep = currentSwitcher?.getElementsByClassName('uk-active')[0] as HTMLElement
            const currentSwitcherActiveStep = Number(activeStep.dataset.step)
            const shouldRedirectToStep = ctaOriginalStep !== currentSwitcherActiveStep

            if (shouldRedirectToStep && this.stepToVisit !== null) {
                this.dispatchCustomEvent(OrganismFormStepperEvents.REQUEST_GO_TO_STEP, this.stepToVisit, false, true)
            }
        }

        this.dispatchCustomEvent(ResumeSliceEvents.TOGGLE_SLICE_FOR_INPUTS, { id: resumeSliceId }, false, true)

    }

}
